'use client';

import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import { ImageProps } from 'next/image';

import { ModalTransformWrapper } from '.';

function AdminImageModal(
  props: ImageProps & { open: boolean; handleClose: () => void }
) {
  return (
    <Modal open={props.open} onClose={props.handleClose}>
      <Box>
        <ModalTransformWrapper {...props} />
      </Box>
    </Modal>
  );
}

export default AdminImageModal;
